/* eslint-disable @typescript-eslint/no-var-requires */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import marked from "marked";
import { useSnackbar } from "material-ui-snackbar-provider";
import { useEffect, useState } from "react";
import * as React from "react";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Changelog from "../../../CHANGELOG.md";
import MarkdownElement from "../../../components/MarkdownElement";

interface Props {
  onClose: () => void;
  open: boolean;
}

const ChangelogDialog: React.FunctionComponent<Props> = ({ open, onClose }) => {
  const [changelog, setChangelog] = useState("");
  const snackbar = useSnackbar();

  useEffect(() => {
    loadChangelog();
  });

  const loadChangelog = async () => {
    const response = await fetch(Changelog);
    try {
      const text = await response.text();
      setChangelog(marked(text));
    } catch {
      snackbar.showMessage(
        "Die Versionshinweise konnten nicht geladen werden."
      );
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth={"md"} onClose={onClose}>
      <DialogTitle>Versionshinweise</DialogTitle>
      <DialogContent>
        <MarkdownElement renderedMarkdown={changelog} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangelogDialog;
